import React from 'react'
import propTypes from 'prop-types'

import LoadingIndicator from '@/components/LoadingIndicator'
import { ReportTable } from '@/components/report-tables'
import ErrorBoundary from '@/components/ErrorBoundary'

class InstitutionReportTable extends React.PureComponent {
    static propTypes = {
      sourceData: propTypes.array,
      isLoading: propTypes.bool,
      institutionReport: propTypes.object,
      sourceHeaders: propTypes.object,
      sourceRowHeaders: propTypes.object,
      isRtl: propTypes.bool,
      cellMetadata: propTypes.array
    }

    render () {
      if (this.props.isLoading) { return <LoadingIndicator /> }
      if (this.props.institutionReport) {
        return <React.Fragment>
          <ErrorBoundary>
            <ReportTable
              isRtl={this.props.isRtl}
              sourceHeaders={this.props.sourceHeaders}
              sourceRowHeaders={this.props.sourceRowHeaders}
              sourceData={this.props.sourceData}
              defaultMetadata={{ readOnly: true }}
              cellMetadata={this.props.cellMetadata}
              renderAllRows
              readOnly />
          </ErrorBoundary>
        </React.Fragment>
      }
      return null
    }
}

export { InstitutionReportTable }



// WEBPACK FOOTER //
// ./src/internal-app/pages/institutionReports/institutionReportTable.js